/**
 * One palette for "which channel is this agent for" — shared by the agents table tags and the
 * deactivate dialog so the same channel is always the same colour:
 *
 *   WhatsApp           → green   (WhatsApp's own brand green family)
 *   Instagram          → pink    (the pink end of Instagram's logo gradient)
 *   Web chat/fallback  → blue
 *
 * `bg` is the soft tint used behind text/icons, `fg` the readable foreground on it.
 */
export type ChannelKey = 'whatsapp' | 'instagram' | 'webChat' | 'fallback';

export const CHANNEL_TONE: Record<ChannelKey, { bg: string; fg: string }> = {
  whatsapp: { bg: '#dcfce7', fg: '#15803d' },
  instagram: { bg: '#fce7f3', fg: '#be185d' },
  webChat: { bg: '#dbeafe', fg: '#1d4ed8' },
  fallback: { bg: '#dbeafe', fg: '#1d4ed8' },
};
